import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "pb-4" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "mb-4 banner banner-danger"
}
const _hoisted_4 = { class: "w-full" }
const _hoisted_5 = { class: "flex items-center space-x-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined text-danger-dark" }, " school ", -1)
const _hoisted_7 = { class: "font-semibold text-danger-dark" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { class: "text-danger-dark" }
const _hoisted_12 = { class: "flex items-center mt-8 space-x-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "opacity-0 material-icons-outlined" }, " school ", -1)
const _hoisted_14 = { class: "grid gap-4 md:gap-8 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4" }
const _hoisted_15 = {
  key: 1,
  class: "grid gap-8 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4"
}
const _hoisted_16 = {
  key: 2,
  class: "flex flex-col w-full text-center select-none mt-28"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", {
  style: {"font-size":"5rem"},
  class: "mr-auto material-icons-outlined opacity-10"
}, " west ", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", {
  style: {"font-size":"10rem"},
  class: "-mt-12 material-icons-outlined opacity-10"
}, " book ", -1)
const _hoisted_19 = { class: "opacity-40" }
const _hoisted_20 = {
  key: 3,
  class: "flex flex-col w-full text-center select-none mt-28"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", {
  style: {"font-size":"10rem"},
  class: "-mt-12 material-icons-outlined opacity-10"
}, " search_off ", -1)
const _hoisted_22 = { class: "opacity-40" }
const _hoisted_23 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CourseSearchFilters = _resolveComponent("CourseSearchFilters")!
  const _component_NumberInput = _resolveComponent("NumberInput")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_StudentScopesBanner = _resolveComponent("StudentScopesBanner")!
  const _component_CourseListItem = _resolveComponent("CourseListItem")!
  const _component_CourseListItemSkeleton = _resolveComponent("CourseListItemSkeleton")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_v_tour = _resolveComponent("v-tour")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.firstLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_CourseSearchFilters, {
            class: "mb-8",
            modelValue: _ctx.searchFilters,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchFilters) = $event))
          }, null, 8, ["modelValue"]),
          (
					!_ctx.metaStore.user.is_teacher &&
					(!_ctx.metaStore.user.mat || !_ctx.metaStore.user.course) &&
					!_ctx.isDemoMode
				)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _hoisted_6,
                    _createElementVNode("div", null, [
                      _createElementVNode("p", _hoisted_7, [
                        _createTextVNode(_toDisplayString(_ctx.$t("student_data.you_havent_yet")) + " ", 1),
                        (!_ctx.metaStore.user.mat)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t("student_data.missing_mat")), 1))
                          : _createCommentVNode("", true),
                        (!_ctx.metaStore.user.mat && !_ctx.metaStore.user.course)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_9, " & "))
                          : _createCommentVNode("", true),
                        (!_ctx.metaStore.user.course)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.$t("student_data.missing_course")), 1))
                          : _createCommentVNode("", true),
                        _createTextVNode(". ")
                      ]),
                      _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t("student_data.insert_mat_and_course")), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    (!_ctx.metaStore.user.mat)
                      ? (_openBlock(), _createBlock(_component_NumberInput, {
                          key: 0,
                          class: "w-96 text-darkText",
                          modelValue: _ctx.dirtyMat,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dirtyMat) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("student_data.your_mat")), 1)
                          ]),
                          _: 1
                        }, 8, ["modelValue"]))
                      : _createCommentVNode("", true),
                    (!_ctx.metaStore.user.course)
                      ? (_openBlock(), _createBlock(_component_Dropdown, {
                          key: 1,
                          class: "w-96",
                          id: "course-select",
                          options: [
								{ value: null, content: 'Seleziona il corso' },
								{ value: 'A', content: 'A' },
								{ value: 'B', content: 'B' },
								{ value: 'C', content: 'C' },
							],
                          modelValue: _ctx.dirtyCourse,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dirtyCourse) = $event)),
                          placeholder: _ctx.$t('student_data.select_course')
                        }, null, 8, ["modelValue", "placeholder"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_Btn, {
                      variant: 'primary',
                      loading: _ctx.localLoading,
                      disabled: String(_ctx.dirtyMat).length === 0 && !_ctx.dirtyCourse,
                      onClick: _ctx.onSaveMat,
                      class: "ml-auto"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("misc.save_and_close")), 1)
                      ]),
                      _: 1
                    }, 8, ["loading", "disabled", "onClick"])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.metaStore.user.is_teacher)
            ? (_openBlock(), _createBlock(_component_StudentScopesBanner, { key: 1 }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.coursesFiltered, (course, index) => {
              return (_openBlock(), _createBlock(_component_CourseListItem, {
                key: 'course-' + course.id,
                course: course,
                id: index === 0 ? 'course-0' : '',
                onToggleFavorite: ($event: any) => (_ctx.onCourseToggleFavorite(course)),
                onEnroll: ($event: any) => (_ctx.onEnrollChange(course, 'enroll')),
                onUnenroll: ($event: any) => (_ctx.onEnrollChange(course, 'unenroll'))
              }, null, 8, ["course", "id", "onToggleFavorite", "onEnroll", "onUnenroll"]))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createVNode(_component_CourseListItemSkeleton),
          _createVNode(_component_CourseListItemSkeleton),
          _createVNode(_component_CourseListItemSkeleton),
          _createVNode(_component_CourseListItemSkeleton),
          _createVNode(_component_CourseListItemSkeleton),
          _createVNode(_component_CourseListItemSkeleton),
          _createVNode(_component_CourseListItemSkeleton, { class: "hidden 2xl:block" }),
          _createVNode(_component_CourseListItemSkeleton, { class: "hidden 2xl:block" }),
          _createVNode(_component_CourseListItemSkeleton, { class: "hidden 2xl:block" }),
          _createVNode(_component_CourseListItemSkeleton, { class: "hidden 2xl:block" })
        ])),
    (!_ctx.firstLoading && _ctx.mainStore.courses.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _hoisted_17,
          _hoisted_18,
          _createElementVNode("h2", _hoisted_19, _toDisplayString(_ctx.$t("course_list.no_courses")), 1)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.firstLoading && _ctx.mainStore.courses.length > 0 && _ctx.coursesFiltered.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("h2", _hoisted_22, _toDisplayString(_ctx.$t("course_list.no_courses_with_filters")), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Dialog, {
      loading: _ctx.enrollmentLoading,
      yesText: 
				_ctx.enrollmentLoading
					? _ctx.$t('misc.wait')
					: _ctx.enrollmentDialogMode === 'enroll'
					? _ctx.$t('enrollment.enroll')
					: _ctx.$t('enrollment.unenroll')
			,
      noText: _ctx.$t('dialog.default_cancel_text'),
      disableOk: _ctx.enrollmentLoading,
      showDialog: _ctx.showBlockingDialog,
      onYes: _cache[3] || (_cache[3] = ($event: any) => (_ctx.resolveBlockingDialog(true))),
      onNo: _cache[4] || (_cache[4] = ($event: any) => (_ctx.resolveBlockingDialog(false)))
    }, _createSlots({
      body: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.enrollmentDialogMode === "enroll"
						? _ctx.$t("enrollment.do_you_want_to_enroll")
						: _ctx.$t("enrollment.do_you_want_to_unenroll")) + " ", 1),
        (_ctx.selectedCourseForEnrollment)
          ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.selectedCourseForEnrollment.name), 1))
          : _createCommentVNode("", true),
        _createTextVNode(" ?")
      ]),
      _: 2
    }, [
      (_ctx.enrollmentDialogMode === 'enroll')
        ? {
            name: "title",
            fn: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("enrollment.enrollment")), 1)
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["loading", "yesText", "noText", "disableOk", "showDialog"]),
    _createVNode(_component_v_tour, {
      name: "demoCourseTour",
      steps: _ctx.demoCourseTourSteps,
      options: _ctx.tourOptions
    }, null, 8, ["steps", "options"])
  ]))
}